import {
  FaHotel,
  FaGlassCheers,
  FaEnvelopeOpenText,
  FaMusic,
} from "react-icons/fa";

const ManageSection = () => {
const services = [
  {
    title: "Venue Booking",
    desc: "Stunning destinations that match your vision and budget.",
    icon: FaHotel,
  },
  {
    title: "Wedding Planning",
    desc: "Bespoke designs that bring your wedding dreams to life.",
    icon: FaGlassCheers,
  },
  {
    title: "Hospitality & RSVP",
    desc: "Thoughtful guest coordination with warmth and care.",
    icon: FaEnvelopeOpenText,
  },
  {
    title: "Artist Management",
    desc: "From photographers to DJs, we make every moment unforgettable.",
    icon: FaMusic,
  },
];


  return (
    <section className="relative bg-gray-50 py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-serif text-gray-800">
            We <span className="text-[#b76d68]">Manage</span> Everything
          </h2>
          <p className="text-gray-500 mt-4 font-outfit">
            Our exclusive services ensure every detail is unforgettable
          </p>

          {/* Decorative Dots */}
          <div className="flex justify-center items-center gap-3 mt-6">
            <div className="w-10 h-[1px] bg-red-300"></div>
            <div className="w-2 h-2 bg-red-400 rounded-full"></div>
            <div className="w-10 h-[1px] bg-red-300"></div>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="bg-white cursor-pointer rounded-2xl shadow-md hover:shadow-xl transition duration-300 p-8 text-center"
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-red-100 text-[#b76d68] mb-6">
                  <Icon size={32} />
                </div>

                <h3 className="text-xl font-quicksand font-semibold text-gray-800 mb-3">
                  {item.title}
                </h3>

                <p className="text-sm font-outfit text-gray-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Background Soft Circles */}
      <div className="absolute w-72 h-72 border border-red-200 rounded-full top-20 right-10 opacity-20"></div>
      <div className="absolute w-40 h-40 border border-red-200 rounded-full bottom-10 left-10 opacity-20"></div>
    </section>
  );
};

export default ManageSection;
